export default "__VITE_ASSET__495caa6c__"